import { render, staticRenderFns } from "./OcrPageSelect.vue?vue&type=template&id=fe2355a2&scoped=true&"
import script from "./OcrPageSelect.vue?vue&type=script&lang=js&"
export * from "./OcrPageSelect.vue?vue&type=script&lang=js&"
import style0 from "./OcrPageSelect.vue?vue&type=style&index=0&id=fe2355a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2355a2",
  null
  
)

export default component.exports